import { commandDefinition, optionsDefinition } from "../../Commons/Options/CommandBasedOptionsParser";
import { CommonOptions } from "../CommonOptions/CommonOptions";
import { devModeOption, logVerbosityOption } from "../CommonOptions/CommonOptionDefintions";

export interface LocalizationOptions extends CommonOptions {
    gfv: string;
    useLocalGeneratorSources: boolean;
    dictionaryOnly: boolean;
}

export const localizationCommandDefinition = commandDefinition<"localize", LocalizationOptions>(
    "localize",
    "localize",
    optionsDefinition(
        {
            alias: "g",
            name: "gfv",
            defaultValue: { gfv: "" },
            parse: (input: string) => ({ gfv: input }),
            defaultOption: true,
            description: "GFV формы для локализации",
        },
        {
            alias: "d",
            name: "dictionary-only",
            defaultValue: { dictionaryOnly: false },
            parse: input => ({ dictionaryOnly: input }),
            doesNotRequireValue: true,
            description: "Создать словарь локализации без изменения сахара",
        },
        {
            name: "use-local-generator-sources",
            defaultValue: { useLocalGeneratorSources: false },
            parse: input => ({ useLocalGeneratorSources: input }),
            doesNotRequireValue: true,
            description:
                "Использовать исходный код генератора из локальной рабочей копии. Используется в режиме разработке.",
        },
        devModeOption,
        logVerbosityOption
    ),
    {
        description: "Локализация формы. Подготавливает текстовые поля в сахаре для перевода и создает словарь",
    }
);
